import { api } from '../services/api';
export const getOpenGraphMetadata = (url) => api.get('/external/opengraph', {
    query: {
        url,
    },
});
